import { csrfHeaders } from "./csrf";
import { clearAuthSession } from "./clearAuthSession";

export async function fetchWithAuth(url, options = {}) {
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
  const headers = csrfHeaders({
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...(options.headers || {}),
  });
  if (isFormData) {
    delete headers["Content-Type"];
  }

  const finalOptions = {
    ...options,
    credentials: "include",
    headers,
  };

  try {
    const response = await fetch(url, finalOptions);

    if (response.status === 401) {
      console.warn("Session expired. Clearing auth storage and logging out...");
      clearAuthSession({ redirect: true });
      const error = new Error("Session expired");
      error.status = 401;
      throw error;
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const message = errorData.error || errorData.message || `Request failed with status ${response.status}`;
      const error = new Error(message);
      error.status = response.status;
      error.data = errorData;
      throw error;
    }

    return response;
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
}
